export class ApiErrorHelper {

    static isBlacklistedToken(error: any): boolean {
        if (error?.status !== 403) {
            return false;
        }

        const response = error?.error;
        const message = [
            typeof response === 'string' ? response : null,
            response?.message,
            response?.error,
            response?.code,
            ...(Array.isArray(response?.messages) ? response.messages : [])
        ]
            .filter((value) => typeof value === 'string')
            .join(' ')
            .toLowerCase();

        return /blacklist|blacklisted|revoked|revo(c|k)ed|invalid token|token invalido|token inválido|Token is blacklisted/.test(message);
    }

    static extractMessage(error: any): string {
        
        if (error?.error?.messages && typeof error.error.messages === 'object') {
            return Object.values(error.error.messages).join('\n');
        }

        if (error?.error?.message) {
            return String().concat('\n').concat(error.error.message);
        }

        if (error?.error?.error) {
            return error.error.error;
        }

        if (typeof error?.error === 'string') {
            return error.error;
        }

        return 'Ocorreu um erro inesperado.';
    }

}
